import {z} from 'zod';
import {
	editRemovesFromFilter,
	getDefaultFilters,
	makeOptionalPropsNullable,
	type EditRemovesFromFilterParams,
	type GetDefaultFiltersParams,
} from '@netx/core-schema';
import {
	SharedResourceSchema,
	type ISharedResource,
	SharedResourceField,
} from './sharedResourceSchema';

export const SharedResourceFilterSchema = makeOptionalPropsNullable(
	SharedResourceSchema.partial().pick({
		[SharedResourceField.title]: true,
	}),
);

export const SharedResourceFilterableField =
	SharedResourceFilterSchema.keyof().enum;

export const SHARED_RESOURCE_FILTERABLE_FIELDS = Object.values(
	SharedResourceFilterableField,
);

export type SharedResourceFilter = z.infer<typeof SharedResourceFilterSchema>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getSharedResourceDefaultFilters = (
	params?: Omit<
		GetDefaultFiltersParams<SharedResourceFilter>,
		'filterableFields'
	>,
): SharedResourceFilter =>
	getDefaultFilters({
		...params,
		filterableFields: SHARED_RESOURCE_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const sharedResourceEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<ISharedResource, SharedResourceFilter>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: SharedResourceSchema,
	});
